export const generateRequestKey = (prefix: string = '') => {
  return new Date().getTime().toString() + '_' + prefix
}
